export function documentListScripts(): void {
    let documentTagButtons = document.querySelectorAll(".bg-document-list-tag-button");
    if (documentTagButtons.length > 0) {
        documentTagButtons.forEach(button => {
            button.addEventListener("click", () =>{
                button.classList.toggle("selected")
            })

        })
    }
}